<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <h6>Current Balance: {{currentBalance}}</h6>
                    <data-table :headings="customerTransactionHistoryHeadings" :data="customerTransactionHistory" :hasActions="false"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button id="btnLoadCredits" class="btn btn-primary mr-2" @click="onLoadCreditsClick">Load Credits</button>
                                <button id="btnReduceCredits" class="btn btn-primary mr-2" @click="onReduceCreditsClick">Reduce Credits</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <from-date-to-date-pickers  :title="'Transaction Date'"
                                                            :fromDate="filter.fromDateCreated"
                                                            :toDate="filter.toDateCreated"
                                                            :elementId="'transactionDateFilter'"
                                                            :dateFormat="'DD/MM/YYYY'"
                                                            @clearDatePicker="onDateFilterClearClick"
                                                            @fromDateSelected="onFromDateCreatedSelect"
                                                            @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    <modal-form 
        :heading="loadCreditsFormModal.heading" 
        :modalId="loadCreditsFormModal.modalId" 
        :isSaving="loadCreditsFormModal.isSaving" 
        :showModal="loadCreditsFormModal.showModal"
        @closeClicked="onLoadCreditsCloseClick"
        @saveButtonClicked="onLoadCreditsModalSaveButtonClicked">
        <template #form>
            <h6>Current Balance: {{currentBalance}}</h6>
            <form>
                <div class="form-group">
                    <label>
                        Amount to Load
                    </label>
                    <div class="text-danger" v-if="loadCreditsFormModal.loadCredits.amountToLoad.hasError">
                        {{loadCreditsFormModal.loadCredits.amountToLoad.errorMessage}}
                    </div>
                    <currency-input class="form-control" v-model="loadCreditsFormModal.loadCredits.amountToLoad.value"
                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>
<!--                    <input type="number" class="form-control" id="amountToLoadInput" v-model="loadCreditsFormModal.loadCredits.amountToLoad">-->
                </div>
                <div>
                    <div class="form-group">
                        <label for="commentLoadInput">
                            Comments
                        </label>
                        <textarea class="form-control" id="commentLoadInput" v-model="loadCreditsFormModal.loadCredits.comments"></textarea>
                    </div>
                </div>
            </form>
        </template>
    </modal-form>

    <modal-form 
        :heading="reduceCreditsFormModal.heading" 
        :modalId="reduceCreditsFormModal.modalId" 
        :isSaving="reduceCreditsFormModal.isSaving" 
        :showModal="reduceCreditsFormModal.showModal"
        @closeClicked="onReduceCreditsCloseClick"
        @saveButtonClicked="onReduceCreditsModalSaveButtonClicked">
        <template #form>
            <h6>Current Balance: {{currentBalance}}</h6>
            <form>
                <div class="form-group">
                    <label>
                        Amount to Reduce
                    </label>
                    <div class="text-danger" v-if="reduceCreditsFormModal.reduceCredits.amountToReduce.hasError">
                        {{reduceCreditsFormModal.reduceCredits.amountToReduce.errorMessage}}
                    </div>
                    <currency-input class="form-control" v-model="reduceCreditsFormModal.reduceCredits.amountToReduce.value"
                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>
<!--                    <input type="number" class="form-control" id="amountToLoadInput" v-model="reduceCreditsFormModal.reduceCredits.amountToReduce">-->
                </div>
                <div>
                    <div class="form-group">
                        <label for="commentReduceInput">
                            Comments
                        </label>
                        <textarea class="form-control" id="commentReduceInput" v-model="reduceCreditsFormModal.reduceCredits.comments"></textarea>
                    </div>
                </div>
            </form>
        </template>
    </modal-form>
</div>
